{
  "actionbar.actions": "Действия",
  "actionbar.actionsAvailable": "Возможно выполнение действий.",
  "actionbar.clearSelection": "Очистить выбор",
  "actionbar.selected": "Выбрано: {count}",
  "actionbar.selectedAll": "Выбрано все",
  "button.pending": "в ожидании",
  "calendar.invalidSelection": "Выбранные {selectedCount, plural, one {дата} other {даты}} недоступны.",
  "contextualhelp.help": "Справка",
  "contextualhelp.info": "Информация",
  "datepicker.endTime": "Время окончания",
  "datepicker.startTime": "Время начала",
  "datepicker.time": "Время",
  "dialog.alert": "Предупреждение",
  "dialog.dismiss": "Пропустить",
  "dropzone.replaceMessage": "Перетащите файл для замены",
  "inlinealert.informative": "Информация",
  "inlinealert.negative": "Ошибка",
  "inlinealert.notice": "Предупреждение",
  "inlinealert.positive": "Успешно",
  "label.(optional)": "(дополнительно)",
  "label.(required)": "(обязательно)",
  "menu.moreActions": "Дополнительные действия",
  "picker.placeholder": "Выбрать…",
  "slider.maximum": "Максимум",
  "slider.minimum": "Минимум",
  "table.loading": "Загрузка...",
  "table.loadingMore": "Дополнительная загрузка...",
  "table.resizeColumn": "Изменить размер столбца",
  "table.sortAscending": "Сортировать по возрастанию",
  "table.sortDescending": "Сортировать по убыванию",
  "tag.actions": "Действия",
  "tag.hideButtonLabel": "Показать меньше",
  "tag.noTags": "Нет",
  "tag.showAllButtonLabel": "Показать все ({tagCount, number})",
  "breadcrumbs.more": "Дополнительные элементы",
  "combobox.noResults": "Результаты отсутствуют",
  "notificationbadge.indicatorOnly": "Новая активность",
  "notificationbadge.plus": "{notifications}+",
  "toast.clearAll": "Clear all",
  "toast.collapse": "Collapse",
  "toast.showAll": "Show all"
}